import { useQuery } from '@tanstack/react-query';
import { directoryApi, type MapsConfig } from '../client';

export const mapsConfigKeys = {
  all: ['directory', 'maps', 'config'] as const,
};

/**
 * The map providers' settings for this environment (Google browser key, Azure
 * Maps client id). Fetched once per session — they change only on a deploy.
 * Signed-in only, so call it inside the authenticated shell.
 */
export function useMapsConfig() {
  return useQuery<MapsConfig, Error>({
    queryKey: mapsConfigKeys.all,
    queryFn: () => directoryApi.getMapsConfig(),
    staleTime: Infinity,
    gcTime: Infinity,
    retry: 1,
  });
}
